import { render, staticRenderFns } from "./PatrolsVertical.vue?vue&type=template&id=7e24f0d9"
import script from "./PatrolsVertical.vue?vue&type=script&lang=js"
export * from "./PatrolsVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports